import { getEntitlementDefaults } from '@atlassian/temp-proxies';
import { EntitlementDefaultsResponse } from '@atlassian/cssxp-types-entitlement';
import { RelationshipPathType } from '@atlassian/cssxp-typescommon';
import { BillingFrequency } from '@css-xp/graphtypes/src/generated-types-new';

export const getOrderDefaults = async ({
  offeringId,
  transactionAccountId,
  containerId,
}: {
  offeringId: string;
  transactionAccountId: string;
  containerId: string;
}): Promise<EntitlementDefaultsResponse> => {
  return await getEntitlementDefaults({
    offeringId,
    transactionAccountId,
    relatedEntitlementId: containerId,
    relationshipType: RelationshipPathType.FAMILY_CONTAINER,
    billingCycle: BillingFrequency.MONTHLY,
  });
};
